import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ROUTER_SERVICE_TOKEN } from '@ideapa/app-common';
import { AppUiKitModule } from '@ideapa/app-ui-kit';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';

import { RouterFacade } from './+state/router.facade';
import { CustomSerializer } from './custom-serializer';
import { ModalWrapperComponent } from './modal-wrapper.component';
import { ngrxRouterFeatureKey } from './router.interfaces';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(ngrxRouterFeatureKey, routerReducer),
    StoreRouterConnectingModule.forRoot({
      stateKey: ngrxRouterFeatureKey,
      serializer: CustomSerializer,
    }),
    AppUiKitModule,
  ],
  declarations: [ModalWrapperComponent],
  providers: [
    {
      provide: ROUTER_SERVICE_TOKEN,
      useClass: RouterFacade,
    },
  ],
})
export class AppRoutingUtilsModule {}
